import { AxiosInstance } from 'axios';

export default class AppService {
  servicePath: string;

  api: AxiosInstance;

  constructor(servicePath: string, api: AxiosInstance) {
    this.servicePath = servicePath;
    this.api = api;
  }

  root(resource?: string | number) {
    if (resource) {
      return `${this.servicePath}/${resource}`;
    }

    return this.servicePath;
  }
}
